const FromArr = [{
		modelvalue: "",
		title: "经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
	},
	{
		modelvalue: "",
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 70,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		modelvalue: "",
		title: "合同状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		modelvalue: "",
		title: "开户状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		modelvalue: "",
		title: "是否从公司订货：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
				value: "是",
				key: "1",
			},
			{
				value: "否",
				key: "0",
			},
		],
	},
	{
		modelvalue: "",
		title: "证照状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 47,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
				value: "不限",
				key: "",
			},
			{
				value: "三证正常",
				key: "1",
			},
			{
				value: "未上传",
				key: "0",
			},
		],
	},
];
export default FromArr;